import { appointmentsQueryFilterOptions } from "../types";

export const appointmentsKeys = {
    all: ["appointments"] as const,
    appointments: (opts: appointmentsQueryFilterOptions) => [...appointmentsKeys.all, opts] as const,
    calendarAppointments: (opts: appointmentsQueryFilterOptions) => [...appointmentsKeys.all, "calendar", opts] as const,
    todayEncounterAppointments: (opts: appointmentsQueryFilterOptions) => [...appointmentsKeys.all, "today", opts] as const,
  } as const;

